import gql from 'graphql-tag';

export const DataGridColumnQuery = gql`
  query DataGridColumn($id: ID!)
{
  DataGridColumn(id:$id) {
    headerName
    order
    isDisplayDetail
    visible
    toolTip
    actionColumn
    actionColumnType
    group
    icon
    hrefValue
    dateFormat
    hyperLink
    key
    expressionAvailable
    editabilityRegex
    width
    fixColumn
    goToLink
    accessibilityRegex
    dbCode
    filterEnable
    filterType
    isPrimaryKey
    isEllipsesEnable
    isDefaultEditable
    isShowOnlyOnEdit
    collapseIcon
    isAuditColumnJson
    auditColumnName
    columnDataAlignment
    columnHeaderAlignment
    isTimeStamp
    datasourceId
    multivalueList
    selectItemsReferenceID
    modalCss
    configObjectId
    name
    configObjectType
    createdBy
    isDeleted
    itemDescription
    insert_ts
    projectId
    updatedBy
    update_ts
    deletionDate
    columnType
  childRelations {
          relationType
          childItemId
          insert_ts
          update_ts
          createdBy
          updatedBy
        }
        parentRelations {
          relationType
          parentItemId
          insert_ts
          update_ts
          createdBy
          updatedBy
        }
        privileges {
          privilegeType
          roleId
          insert_ts
          update_ts
          createdBy
          updatedBy
        }
  }
  }`;